import { Component, Input, OnInit } from '@angular/core';
import { Unit, units } from '../../../models/unit';

@Component({
  selector: 'app-unit',
  standalone: true,
  imports: [],
  templateUrl: './unit.component.html',
  styleUrl: './unit.component.scss',
})
export class UnitComponent implements OnInit {
  @Input() unitKey = '';
  @Input() mode: 'name' | 'key' | 'short' | 'long' | 'symbol' = 'symbol';
  selectedUnit!: Unit;

  ngOnInit() {
    this.selectedUnit = units[this.unitKey || '1'];
  }
}
